module.exports = __webpack_public_path__ + "static/meningitis-b-0b7d8557cd91de3e71a3c25b3aaa88a6.png";